import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function BalconyDoor(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M8 3a2 2 0 00-2 2v3.085c2.049-.49 3.315-1.823 4.105-3.155.411-.694.687-1.38.866-1.93H8zM6 16v-4.774A11.322 11.322 0 018.072 16H6zm3.593 0a12.822 12.822 0 00-3.066-6.5c2.437-.64 3.956-2.266 4.868-3.805.206-.347.382-.691.532-1.02.132.324.29.661.48 1.002.88 1.582 2.422 3.22 5.048 3.843A12.821 12.821 0 0014.407 16H9.593zm6.157 2H4v2a1 1 0 001 1h14a1 1 0 001-1v-2h-4.25zm.178-2A11.323 11.323 0 0118 11.226V16h-2.072zM18 8.104V5a2 2 0 00-2-2h-3.053c.143.55.38 1.246.771 1.948C14.453 6.27 15.726 7.63 18 8.104zM20 16V5a4 4 0 00-4-4H8a4 4 0 00-4 4v11H2a1 1 0 100 2v2a3 3 0 003 3h14a3 3 0 003-3v-2a1 1 0 100-2h-2z",
    clipRule: "evenodd"
  }));
}

export default BalconyDoor;